import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { waitForOffice } from "./bootstrap";

// Initialize Office in background — don't block React render on Mac timer freeze
void waitForOffice(typeof Office === "undefined" ? undefined : Office);

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")
);
